import React from 'react';

interface IPropsIconeAguia {
    htmlColor?: string;
    icone1?: boolean;
    size?: number | string;
}

export default class IconeAguia extends React.Component<IPropsIconeAguia> {

    render() {
        const size = this.props.size || 24;

        if (this.props.icone1) {
            return (
                <svg width={size} height={size} viewBox="0 0 93 93" fill="var(--cor-base-icone-aguia, black)" xmlns="http://www.w3.org/2000/svg">
                    {/* <rect width="93" height="93" rx="12" fill="#005F8F" /> */}
                    <rect x="22" y="16" width="7" height="63" fill="url(#paint0_linear_1009_8)" />
                    <path d="M74.5 57H32H31V54H72.5C73.1198 52.3004 72.7323 50.5222 70.5 49.5H64.5L48.5 22C47.7319 20.5378 47 19.5 46.5 19.5H31V16.5H46.5C48.8709 17.0343 49.6343 17.7639 51 19.5L66 46.5H71.5C74.8471 48.1404 76.6689 49.0781 77 51.5V59.5L74.5 57Z" fill="var(--cor-base-icone-aguia, black)" />
                    <path d="M53 50H49L34 23.5H37.5L53 50Z" fill="var(--cor-base-icone-aguia, black)" />
                    <path d="M58.5 61.5H54.5L64.5 78.5H68.5L58.5 61.5Z" fill="var(--cor-base-icone-aguia, black)" />
                    <path d="M67 61.5H62.5L68 71L72.5 78.5H76.5L67 61.5Z" fill="var(--cor-base-icone-aguia, black)" />
                    <path d="M56.5 50H60.5L45.5 23.5H41.5L56.5 50Z" fill="var(--cor-base-icone-aguia, black)" />
                    <path d="M32 57H74.5L77 59.5V51.5C76.6689 49.0781 74.8471 48.1404 71.5 46.5H66L51 19.5C49.6343 17.7639 48.8709 17.0343 46.5 16.5H31V19.5C31 19.5 46 19.5 46.5 19.5C47 19.5 47.7319 20.5378 48.5 22L64.5 49.5H70.5C72.7323 50.5222 73.1198 52.3004 72.5 54H31V57H32ZM49 50H53L37.5 23.5H34L49 50ZM54.5 61.5H58.5L68.5 78.5H64.5L54.5 61.5ZM62 61.5H67L76.5 78.5H72.5L68 71L62.5 61.5H62ZM60.5 50H56.5L41.5 23.5H45.5L60.5 50Z" stroke="var(--cor-base-icone-aguia, black)" />
                    <defs>
                        <linearGradient id="paint0_linear_1009_8" x1="25.5" y1="16" x2="25.5" y2="79" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#1A7CAB" />
                            <stop offset="0.632434" stopColor="#149EA0" />
                            <stop offset="1" stopColor="#1D9491" />
                        </linearGradient>
                    </defs>
                </svg>
            );
        }
        return (
            <svg
                width={size} height={size} viewBox="0 0 55.000000 63.000000"
                preserveAspectRatio="xMidYMid meet">
                <g transform="translate(0.000000,63.000000) scale(0.100000,-0.100000)"
                    fill={this.props.htmlColor || 'currentColor'} stroke="none">
                    <path d="M0 315 l0 -315 35 0 35 0 0 315 0 315 -35 0 -35 0 0 -315z" />
                    <path d="M90 610 c0 -18 7 -20 68 -20 39 0 75 -5 85 -12 9 -7 52 -74 95 -148
                            73 -126 80 -135 113 -140 39 -7 59 -17 59 -31 0 -5 -84 -9 -205 -9 -197 0
                            -205 -1 -205 -20 0 -18 9 -19 208 -22 114 -2 215 -7 225 -12 15 -7 17 -3 17
                            37 0 57 -24 87 -74 96 -37 6 -41 11 -113 136 -40 72 -83 138 -95 148 -15 13
                            -39 17 -99 17 -72 0 -79 -2 -79 -20z"/>
                    <path d="M120 549 c0 -7 32 -67 71 -135 61 -107 74 -124 96 -124 l25 0 -41 74
                            c-88 161 -112 196 -131 196 -11 0 -20 -5 -20 -11z"/>
                    <path d="M194 543 c4 -10 37 -71 74 -135 59 -105 70 -118 94 -118 27 0 27 0
                            -43 123 -83 144 -86 147 -111 147 -15 0 -18 -5 -14 -17z"/>
                    <path d="M330 174 c0 -3 21 -43 47 -90 38 -68 51 -84 70 -84 13 0 23 3 23 6 0
                            4 -21 44 -47 90 -38 66 -53 84 -70 84 -13 0 -23 -3 -23 -6z"/>
                    <path d="M400 173 c1 -5 22 -44 49 -88 33 -55 54 -81 69 -83 12 -2 22 1 22 7
                            0 5 -21 46 -47 90 -37 64 -52 81 -70 81 -13 0 -23 -3 -23 -7z"/>
                </g>
            </svg>
        );
    }
}
